import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const PrivacyPage: React.FC = () => <ContentPage slug="datenschutz" title="Datenschutz" />;

export default PrivacyPage;
